// reloadPageEff :: Effect Unit
export function reloadPageEff() {
  window.location.href = window.location.href.split("#")[0];
}

// setLocation :: String -> Effect Unit
export function setLocation(url) {
  return function () {
    window.location.href = url;
  };
}
